/**
 * Route for `digitalocean-spaces-export-csv-json`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { DigitaloceanSpacesExportCsvJsonPage } from "../features/digitalocean-spaces-export-csv-json/DigitaloceanSpacesExportCsvJsonPage";

export const digitaloceanSpacesExportCsvJsonRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/digitalocean-spaces-export-csv-json",
	component: DigitaloceanSpacesExportCsvJsonPage,
});

export default digitaloceanSpacesExportCsvJsonRoute;
